import { render } from "./WCMobileSubpageHeader.vue?vue&type=template&id=6d3534ce&scoped=true"
import script from "./WCMobileSubpageHeader.vue?vue&type=script&lang=js"
export * from "./WCMobileSubpageHeader.vue?vue&type=script&lang=js"

import "./WCMobileSubpageHeader.vue?vue&type=style&index=0&id=6d3534ce&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d3534ce"]])

export default __exports__